import { render, staticRenderFns } from "./listaProductos.vue?vue&type=template&id=198e1957&"
import script from "./listaProductos.vue?vue&type=script&lang=js&"
export * from "./listaProductos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports